<form [formGroup]="recuperarProyForm" (ngSubmit)="recuperar()">
    <div class="row"> 
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.RECUPERAR.TITULO' | translate}}</ca-label>
            <input caInput formControlName="idPropuesta" placeholder="{{'AUTOS.RECUPERAR.TITULO' | translate}}" type="number"/>
            <ca-hint>{{'AUTOS.RECUPERAR.HINT' | translate}}</ca-hint>
        </ca-form-field>
    </div>
    <div class="col-12 text-right mt-3 mb-3">
        <button type="submit" ca-button class="ca-btn-icon__container ml-2" data-cy="button-search">
            {{'AUTOS.RECUPERAR.BOTON' | translate}}
        </button>
    </div>
</form>